import React from "react";

const AfterBefore = () => {
    return (
        <>
            <div className="dr-header">
                <div className="header-contant">
                    <h1>After-Before</h1>
                    <p>Doctor {" > "} After-Before</p>
                </div>
            </div>

            <div className="gallery">
                <div className="gallery-row">

                    <div className="gallery-col"><img src="/ab1.jpeg" alt="1" /></div>
                    <div className="gallery-col"><img src="/ab2.jpeg" alt="2" /></div>
                    <div className="gallery-col"><img src="/ab3.jpeg" alt="3" /></div>
                    <div className="gallery-col"><img src="/ab4.jpeg" alt="4" /></div>

                    <div className="gallery-col"><img src="/ab5.jpeg" alt="5" /></div>
                    <div className="gallery-col"><img src="/ab6.jpeg" alt="6" /></div>
                    <div className="gallery-col"><img src="/ab7.jpeg" alt="7" /></div>
                    <div className="gallery-col"><img src="/ab8.jpeg" alt="8" /></div>

                    <div className="gallery-col"><img src="/ab9.jpeg" alt="9" /></div>
                    <div className="gallery-col"><img src="/ab10.jpeg" alt="10" /></div>
                    <div className="gallery-col"><img src="/ab11.jpeg" alt="11" /></div>
                    <div className="gallery-col"><img src="/ab12.jpeg" alt="12" /></div>

                    <div className="gallery-col"><img src="/ab13.jpeg" alt="13" /></div>
                    <div className="gallery-col"><img src="/ab14.jpeg" alt="14" /></div>
                    <div className="gallery-col"><img src="/ab15.jpeg" alt="15" /></div>
                    <div className="gallery-col"><img src="/ab16.jpeg" alt="16" /></div>

                </div>
            </div>
        </>
    );
};

export default AfterBefore;